import axios from 'axios';

const CABECALHO_AA = 'LG_ORIGEM_NOVO_AUTOATENDIMENTO';

const createAxiosInstance = (baseUrl) => {
  const axiosInstance = axios.create({
    baseURL: baseUrl || '',
  });

  axiosInstance.interceptors.request.use((request) => {
    // eslint-disable-next-line
    request.headers.common[CABECALHO_AA] = true;

    // eslint-disable-next-line
    request.params = request.params || {};

    // eslint-disable-next-line
    request.params['_ts'] = new Date().getTime();

    return request;
  });

  return axiosInstance;
};

const axiosRequest = createAxiosInstance();

const atualizeUrlBase = (novaUrl) => {
  axiosRequest.defaults.baseURL = novaUrl;
};

export { atualizeUrlBase, createAxiosInstance };

export default axiosRequest;
